import _typeof from "@babel/runtime/helpers/typeof";

/**
 * 将对象转化成参数
 * @param params 参数
 */
export function urlencoded(params) {
  if (_typeof(params) !== 'object') {
    return params;
  }

  var paramsToString = function paramsToString(params, queryString) {
    var argvs = [];

    if (_typeof(params) !== 'object') {
      return;
    }

    Object.keys(params).forEach(function (name) {
      var param = params[name];

      if (_typeof(param) === 'object') {
        argvs = queryString != '' ? argvs.concat(paramsToString(param, queryString + '[' + name + ']')) : argvs.concat(paramsToString(param, name));
      } else if (typeof param !== 'undefined') {
        queryString != '' ? argvs.push(queryString, '[', name, ']', '=', encodeURIComponent(param), '&') : argvs.push(name, '=', encodeURIComponent(param), '&');
      }
    });
    return argvs;
  };

  return paramsToString(params, '').slice(0, -1).join('');
}